export default __webpack_public_path__ + "static/media/stamp.957503d6.svg";